import React, { forwardRef } from 'react';

import SvgSearchIcon from '@components/Images/SearchIcon';

interface SearchBarProps {
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  placeholder?: string;
}

const SearchBar = forwardRef<HTMLInputElement, SearchBarProps>(
  ({ searchTerm, setSearchTerm, placeholder = 'Search by name or email' }, ref) => {
    return (
      <div className="relative max-w-[290px] sm:min-w-[290px]">
        <input
          type="text"
          value={searchTerm}
          name="search"
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={placeholder}
          className="rounded-md h-[37px] w-full border border-grayscale-gray py-0 pl-8 pr-32 font-suisse-intl text-form text-primary-black outline-none dark:border-[var(--light-grayscale-gray)] dark:bg-[var(--light-grayscale-charcoal)]"
          ref={ref}
        />
        <SvgSearchIcon
          data-testid="search-icon"
          className="absolute right-8 top-1/2 h-20 w-20 -translate-y-1/2 text-primary-black"
        />
      </div>
    );
  }
);

SearchBar.displayName = 'SearchBar';

export default SearchBar;
